import React from 'react';
import { Send, MapPin, Phone, Mail, MessageCircle } from 'lucide-react';
import { company, waLink } from '../mock';
import { useEnquiry } from '../context/EnquiryContext';

export default function Contact() {
  const { openEnquiry } = useEnquiry();

  const items = [
    { icon: MapPin, label: 'Registered Office', value: company.registeredOffice },
    { icon: MapPin, label: 'Secondary Office', value: company.secondaryOffice },
    { icon: Phone, label: 'Call Us', value: company.phone },
    { icon: Mail, label: 'Email Us', value: company.email },
  ];

  return (
    <section id="contact" className="py-20 md:py-28 bg-[#f6f8fb]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal">
          <p className="section-eyebrow mb-3"><span className="h-px w-8 bg-[#EA5019] inline-block" /> GET IN TOUCH</p>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-[#0B2545] leading-tight">Let's Plan Your Perfect Getaway.</h2>
          <p className="mt-4 text-slate-500 leading-relaxed max-w-md">Share a few details and our travel experts will craft a personalised itinerary and quote just for you.</p>

          <div className="mt-9 space-y-5">
            {items.map((it) => (
              <div key={it.label} className="flex items-start gap-4">
                <span className="grid place-items-center h-12 w-12 shrink-0 rounded-xl bg-[#0B2545]/5 text-[#EA5019]"><it.icon size={22} /></span>
                <div>
                  <p className="text-xs uppercase tracking-wider text-slate-400 font-semibold">{it.label}</p>
                  <p className="text-[#0B2545] font-medium">{it.value}</p>
                </div>
              </div>
            ))}
          </div>

          <a href={waLink} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#25D366] text-white font-semibold hover:brightness-95 transition-all shadow-[0_10px_26px_rgba(37,211,102,0.35)]">
            <MessageCircle size={20} /> Chat on WhatsApp
          </a>
        </div>

        <div className="reveal bg-white rounded-2xl p-8 md:p-10 shadow-[0_20px_50px_rgba(11,37,69,0.1)] text-center">
          <span className="grid place-items-center h-16 w-16 mx-auto rounded-2xl bg-[#EA5019]/10 text-[#EA5019]"><Send size={30} /></span>
          <h3 className="mt-6 font-heading text-2xl font-extrabold text-[#0B2545]">Send Us an Enquiry</h3>
          <p className="mt-3 text-slate-500 leading-relaxed max-w-sm mx-auto">Flights, hotels, holiday packages, visa, sightseeing & transfers — tell us what you need and we'll get back with the best options.</p>
          <button
            onClick={() => openEnquiry('Package')}
            data-testid="open-enquiry-btn"
            className="mt-7 inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full font-semibold text-white bg-[#EA5019] hover:bg-[#cf4413] transition-all shadow-[0_10px_26px_rgba(234,80,25,0.35)] hover:-translate-y-0.5 duration-200"
          >
            <Send size={18} /> Send Enquiry
          </button>
          <div className="mt-6 flex flex-wrap justify-center gap-2 text-xs text-slate-400">
            {['Flight', 'Hotel', 'Package', 'Visa', 'SightSeeing', 'Transfer'].map((t) => (
              <span key={t} className="px-3 py-1 rounded-full bg-slate-100 text-slate-500 font-medium">{t}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
